import HighchartsReact from 'highcharts-react-official';
import React from 'react';
import Highcharts from 'highcharts';

const QuantityGraph = (props) => {
  const { data = [] } = props;
  const options = {
    tooltip: { enabled: false },
    title: {
      text: null,
    },
    series: [{
      data: data,
    }],
    step:3,
    yAxis: {
      title: {
        text: null,
      },
    }, 
    xAxis: {
      title: {
        text: null,
      },
      labels: {
        enabled: false,
      },
    },
    credits: { enabled: false },
    legend: {
      enabled: false,
    },
  };

  return(
    <HighchartsReact containerProps={{ style: { height: 120, width: 200 }}} highcharts={Highcharts} options={options} />
  );
};

export default QuantityGraph;